(function (window) {
  const SELECTOR = "[data-scrollspy]";
  const { document } = window;
  const observers = [];
  const options = { rootMargin: "-80px 0px 0px" };

  function dispose() {
    let observer;

    while (observers.length) {
      observer = observers.pop();
      observer.disconnect();
      observer = null;
    }
  }

  function intersection(entries) {
    entries.forEach((entry) => {
      const { ref } = entry.target;
      const { links } = ref.closest(SELECTOR);

      if (entry.isIntersecting) {
        links.forEach((link) => {
          link.classList.remove("active");
        });
        ref.classList.add("active");
      }
    });
  }

  function process(container) {
    const observer = new window.IntersectionObserver(intersection, options);

    observers.push(observer);
    container.links = container.querySelectorAll("a");
    container.links.forEach((link) => {
      const [, href] = link.href.split("#");
      const target = document.getElementById(href);

      if (target) {
        target.ref = link;
        observer.observe(target);
      }
    });
  }

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      document.querySelectorAll(SELECTOR).forEach(process);
    },
    { once: true },
  );
  window.addEventListener("beforeunload", dispose, { once: true });
})(globalThis);
